import type { PerpsOnlyStatus } from 'lib/perpsOnlyStatus';

/** GeoComply and known Perps-only account policy are mutually exclusive. */
export function accountRequiresGeoComply(perpsOnlyStatus: PerpsOnlyStatus): boolean {
    return perpsOnlyStatus !== 'perpsOnly';
}
